import { Injectable } from '@angular/core';

@Injectable()
export class ThemeStorageService {
  public get(key: string): any {
    return JSON.parse(localStorage.getItem(this.getFQK(key)));
  }

  public set(key: string, data: any): void {
    localStorage.setItem(this.getFQK(key), JSON.stringify(data));
  }

  public remove(key: string): void {
    localStorage.removeItem(this.getFQK(key));
  }

  // naming-convention disabled because FQK is an acronym
  // tslint:disable-next-line:naming-convention
  public getFQK(key: string): string {
    return 'armor-mat:' + key;
  }
}
